export interface MatchData {
  breederImage: string;
  buyerImage: string;
}

export interface MatchProps extends MatchData {}
